// extracted by mini-css-extract-plugin
export default {"BlackList":"black-list_BlackList__0qJtB"};